// SPDX-FileCopyrightText: Copyright 2025 New Vector Ltd.
// SPDX-FileCopyrightText: Copyright 2025, 2026 Element Creations Ltd.
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial

import { defineMessage } from "react-intl";

export const actionAdd = defineMessage({
  id: "action.add",
  defaultMessage: "Add",
  description: "The label for the add action/button",
});

export const actionCancel = defineMessage({
  id: "action.cancel",
  defaultMessage: "Cancel",
  description: "Label for a cancel action/button",
});

export const actionClear = defineMessage({
  id: "action.clear",
  defaultMessage: "Clear",
  description: "Label for a clear action/button",
});

export const actionClose = defineMessage({
  id: "action.close",
  defaultMessage: "Close",
  description: "Label for a 'close' action/button",
});

export const actionCopy = defineMessage({
  id: "action.copy",
  defaultMessage: "Copy",
  description: "Label for a copy action/button",
});

export const actionDelete = defineMessage({
  id: "action.delete",
  defaultMessage: "Delete",
  description: "Label for a delete action/button",
});

export const actionDone = defineMessage({
  id: "action.done",
  defaultMessage: "Done",
  description: "Label for a done action/button, dismissing a finished dialog",
});

export const actionGoBack = defineMessage({
  id: "action.go_back",
  defaultMessage: "Go back",
  description: "Label for a go back action/button",
});

export const actionRetry = defineMessage({
  id: "action.retry",
  defaultMessage: "Retry",
  description: "Label for a retry action/button",
});

export const actionRemove = defineMessage({
  id: "action.remove",
  defaultMessage: "Remove",
  description: "Label for the remove action/button",
});

export const actionSignOut = defineMessage({
  id: "action.sign_out",
  defaultMessage: "Sign out",
  description: "Label for the sign out menu item",
});

export const commonEmailAddress = defineMessage({
  id: "common.email_address",
  defaultMessage: "Email address",
  description: "Label for an email address",
});

export const commonFilter = defineMessage({
  id: "common.filter",
  defaultMessage: "Filter",
  description: "Label for a filter section/button",
});

export const commonLoading = defineMessage({
  id: "common.loading",
  defaultMessage: "Loading…",
  description:
    "Announced in place of content which has not finished loading yet",
});
